import { ReactNode } from 'react';
import { ObjectLabel, TabBehavior } from '../../../objectScreen.types';

export interface ObjectTabProps {
  tabKey: string;
  label: ObjectLabel;
  behavior: TabBehavior;
  count?: number;
  endIcon?: ReactNode;
  tooltip?: ReactNode;
  testId?: string;
}

export function ObjectTab(_props: ObjectTabProps) {
  return null;
}
